import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PageRelatedContentBlock } from './types/page-related-content-block.type';

// @angular-eslint/component-selector
@Component({
  selector: 'page-related-content-block-container', // eslint-disable-line
  templateUrl: './page-related-content-block-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageRelatedContentBlockContainerComponent {
  @Input('pageContentBlockData') pageBlockData: PageRelatedContentBlock;
}

export const pageRelatedContentBlockContainerResolver = (registry, data) => ({
  pageBlockData: data,
});
